export default __webpack_public_path__ + "static/media/Background 5_00017.27949693.png";